
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import BeneficiarioFormModel from "@/models/Sobrevivencia/BeneficiarioFormModel";
@Component({
  components: {},
})
export default class FormBeneficiario extends Vue {
  @Prop({}) Beneficiario: BeneficiarioFormModel;
  public BeneficiarioModel :BeneficiarioFormModel = new BeneficiarioFormModel()
  public model : string="";
  options = [
    { vale: "1", text: "Menor de 18" },
    { vale: "2", text: "Maroy de 18" },
  ];
  optionsSiNo = [
    { vale: "1", text: "Sí" },
    { vale: "2", text: "No" },
  ];
  
  created(){
     this.BeneficiarioModel.id = this.Beneficiario.id;
  }
  public changeBeneficiario(){
    // console.log("mouseout")
     this.$emit("changeBeneficiario",this.BeneficiarioModel);
    //this.model = this.model;
  }

  @Watch("Beneficiario",{deep:true,immediate:true})
    public BeneficiarioPropChanged(value:BeneficiarioFormModel,oldValue:BeneficiarioFormModel) {
       this.BeneficiarioModel.nombre = value.nombre;
    }
}
